const getPollPayload = ({ accessKey, assignmentId, userId, userUniqueId }) => {
  return JSON.stringify({
    access_key: accessKey,
    user: {
      id: userId,
      unique_id: userUniqueId,
    },
    assignment_id: assignmentId,
  });
};

export default getPollPayload;
